<section class="expense-list-page">
  <div class="col-sm-12 main-content">
    <div class="clearfix container-box">
      <div class="table-holder table-responsive">
        <table class="table table-default table-striped" [hidden]="isEmptyTable$ | async">
          <mat-table #table
                     matSort
                     matSortActive="created"
                     matSortDirection="desc"
                     [dataSource]="dataSource">

            <ng-container matColumnDef="inquirySource">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Source</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.inquirySource}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="touchView">
              <mat-header-cell *matHeaderCellDef> Updated</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span [matTooltip]="element.touch | epoch"
                      matTooltipPosition="above"
                      matTooltipClass="text-center" [innerHtml]="element.touchView"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="guestArrive">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Arrive</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span [matTooltip]="element.guestArrive | epochUTC"
                      matTooltipPosition="above"
                      matTooltipClass="text-center" [innerHtml]="element.guestArriveView"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="guestDepart">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Depart</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span [matTooltip]="element.guestDepart | epochUTC"
                      matTooltipPosition="above"
                      matTooltipClass="text-center" [innerHtml]="element.guestDepartView"></span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="nightsView">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Nights</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.nightsView}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="personCountView">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Guests</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.personCountView}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="total">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Total</mat-header-cell>
              <mat-cell *matCellDef="let element">
                <span [innerHtml]="element.total | rentalCurrencySymbol : element.rentalId | async"></span>
              </mat-cell>
            </ng-container>


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
                     (click)="onBookingDetails(row)"></mat-row>
          </mat-table>

          <mat-paginator #paginator
                         [length]="dataSource?.data?.length"
                         [pageSize]="10"
                         [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
                         [showFirstLastButtons]="true">
          </mat-paginator>
        </table>
        <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType"></app-empty-table>
      </div>
    </div>
  </div>
</section>
